/*eslint-disable*/
import Vue from './build/bootstrap'
import App from './App.vue'
import router from './router'
import {directive as onClickaway} from 'vue-clickaway'
import store from './store'
import i18n from './build/services/vuei18n'

new Vue({
    data () {
        return {
            amountOfUnread: 0,
            amountOfActive: 0,
            amountOfResolved: 0,
            sidebar: null,
            isNextCityDisabled: false,
            continentTransition: false,
            playAgainReadyScreens: 0,
            checkAnswersReadyScreens: 0
        };
    },
    router,
    i18n,
    directives: {
        onClickaway,
    },
    store,
    render: h => h(App)
}).$mount('#app');
